export default {
	Pending: 1,
	Failed: 2,
	Expired: 3,
	Cancelled: 4,
	Voided: 5,
	Unknown: 6,
	Error: 7,
	Complete: 8,
	Declined: 9
};
